module.exports = __webpack_public_path__ + "img/cold-dish.4e533769.svg";